import { shouldUnsubscribe } from "../ShouldUnsubscribe";
export function subscribe(conn, r, ids) {
    const { qID, qPrevID, qPrev } = ids;
    if (typeof r.query === "undefined") {
        return qID;
    }
    if (shouldUnsubscribe(qID, qPrev)) {
        conn.send({
            name: "Unsubscribe",
            params: { id: qID || qPrevID }
        });
    }
    conn.send(r.query);
    return;
}
//# sourceMappingURL=Subscribe.js.map